export default __webpack_public_path__ + "static/media/showcase-vacations.0b35d413.jpg";